import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { rgba } from 'polished';

const StylesTableVariables = theme => ({
  contrast: {
    emphasis: rgba(theme.contrast.base, 0.15)
  }
});

export const styles = theme => ({
  // 1. Remove spacing between table cells.
  // 2. Block element behavior
  // 3. Style
  table: [{
    // 1
    borderCollapse: 'collapse',
    borderSpacing: '0',
    // 2
    width: '100%',
    // 3
    marginBottom: theme.space.base,
    captionSide: 'bottom',
    border: theme.border.base,
    boxShadow: theme.boxShadow.base,
    borderRadius: theme.borderRadius.base,
    tableLayout: 'fixed',
    maxWidth: 'max-content',
    display: 'block',
    overflowX: 'auto',
    'tr:first-of-type': {
      borderTop: 0
    }
  }, theme.settings.contrast.enable && theme.settings.contrast.table && {
    '.u-contrast &': {
      borderColor: theme.contrast.base,
      'tr:first-of-type': {
        borderColor: theme.contrast.base
      }
    }
  }],
  thead: {
    tr: [{
      background: theme.color.panel.base
    }, theme.settings.contrast.enable && theme.settings.contrast.table && {
      '.u-contrast &': {
        background: StylesTableVariables(theme).contrast.emphasis
      }
    }],
    th: [_objectSpread(_objectSpread({
      verticalAlign: 'bottom',
      fontWeight: theme.fontWeight.bold
    }, theme.text.small), {}, {
      textAlign: 'left',
      borderBottom: theme.border.base,
      '&:first-of-type': {
        borderTopLeftRadius: theme.borderRadius.base
      },
      '&:last-of-type': {
        borderTopRightRadius: theme.borderRadius.base
      }
    })]
  },
  tr: [{
    borderTop: theme.border.base,
    '&:hover, &:focus': {
      background: theme.color.panel.base
    }
  }, theme.settings.contrast.enable && theme.settings.contrast.table && {
    '.u-contrast &': {
      borderColor: theme.contrast.base,
      '&:hover': {
        background: StylesTableVariables(theme).contrast.emphasis
      }
    }
  }],
  'th, td': [{
    padding: theme.space.small + theme.space.xsmall,
    '&:last-child': {
      borderRight: 0
    }
  }, theme.settings.contrast.enable && theme.settings.contrast.table && {
    '.u-contrast &': {
      borderColor: theme.contrast.base
    }
  }],
  td: {
    verticalAlign: 'top'
  },
  'caption, tfoot': [_objectSpread(_objectSpread({
    padding: theme.space.small
  }, theme.text.small), {}, {
    color: theme.fontColor.muted,
    'tr:first-of-type': {
      borderTop: theme.border.base
    }
  }), theme.settings.contrast.enable && theme.settings.contrast.table && {
    '.u-contrast &': {
      color: theme.contrast.muted,
      'tr:first-of-type': {
        borderColor: theme.contrast.base
      }
    }
  }]
});